module.exports = __webpack_public_path__ + "img/plus-square.4d485045.svg";